import type {
  GuessCategoryId,
  SkrivelegGameId,
  MysteryVariantId,
} from '../../types';

export const SKRIVELEG_SESSION_MS = 5 * 60 * 1000;
export const SKRIVELEG_MAX_USER_MESSAGES = 12;

export interface SkrivelegGameDef {
  id: SkrivelegGameId;
  title: string;
  description: string;
  emoji: string;
}

export const SKRIVELEG_GAMES: readonly SkrivelegGameDef[] = [
  {
    id: 'guess',
    title: 'Gæt mit emne',
    description: 'Beskriv hemmeligt emne — AI gætter løbende efter hver besked.',
    emoji: '🎯',
  },
  {
    id: 'mystery',
    title: 'Mystery',
    description: 'Interview noget hemmeligt — gæt hvem, hvor eller hvad.',
    emoji: '🔍',
  },
  {
    id: 'persuade',
    title: 'Overbeviseren',
    description: 'Få nogen til at sige ja — med ord alene.',
    emoji: '💬',
  },
];

export interface GuessCategoryDef {
  id: GuessCategoryId;
  label: string;
  hint: string;
}

export const GUESS_CATEGORIES: readonly GuessCategoryDef[] = [
  { id: 'ting', label: 'Ting', hint: 'Genstande og objekter' },
  { id: 'person', label: 'Person', hint: 'Mennesker og roller' },
  { id: 'sted', label: 'Sted', hint: 'Steder og lokationer' },
  { id: 'dyr', label: 'Dyr', hint: 'Dyr fra land, luft og vand' },
];

export interface MysteryVariantDef {
  id: MysteryVariantId;
  title: string;
  description: string;
  emoji: string;
}

export const MYSTERY_VARIANTS: readonly MysteryVariantDef[] = [
  {
    id: 'person',
    title: 'Mystery Person',
    description: 'En kendt person — rigtig eller fiktiv.',
    emoji: '👤',
  },
  {
    id: 'place',
    title: 'Mystery Sted',
    description: 'Et sted du kender — uden at høre navnet.',
    emoji: '📍',
  },
  {
    id: 'object',
    title: 'Mystery Genstand',
    description: 'En ting der svarer i første person.',
    emoji: '🔧',
  },
];

export function formatSkrivelegDuration(ms: number): string {
  const s = Math.ceil(ms / 1000);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m > 0 ? `${m}:${String(r).padStart(2, '0')}` : `${r}s`;
}

export function starsLabel(count: number): string {
  return '★'.repeat(count) + '☆'.repeat(Math.max(0, 5 - count));
}

export function skrivelegGameDef(id: SkrivelegGameId) {
  return SKRIVELEG_GAMES.find((g) => g.id === id);
}

export function mysteryVariantDef(id: MysteryVariantId) {
  return MYSTERY_VARIANTS.find((v) => v.id === id);
}
